var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrianguloBlanco(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    zoomAndPan: "magnify",
    viewBox: "0 0 96 95.999999",
    height: 128,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "77ec1e3b39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 9 L 96 9 L 96 93 L 0 93 Z M 0 9 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "da461d4ced"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 72.179688 -31.332031 L 119.355469 51.414062 L 47.6875 92.273438 L 0.507812 9.527344 Z M 72.179688 -31.332031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "64a83106ee"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 72.179688 -31.332031 L 119.355469 51.414062 L 47.6875 92.273438 L 0.507812 9.527344 Z M 72.179688 -31.332031 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c4e2c06c97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 72.179688 -31.332031 L 119.355469 51.414062 L 47.6875 92.273438 L 0.507812 9.527344 Z M 72.179688 -31.332031 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#77ec1e3b39)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#da461d4ced)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#64a83106ee)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c4e2c06c97)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f7f7f7",
    d: "M 0.515625 9.523438 L 95.761719 10.042969 L 47.691406 92.269531 Z M 0.515625 9.523438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrianguloBlanco);
export default __webpack_public_path__ + "static/media/triangulo-blanco.191da4b17f3af0a8c78f0881d75c0f10.svg";
export { ForwardRef as ReactComponent };